import {useEffect, useState} from "react";
import {fetchFirstSignInMethod} from "../../firebase";
import {AuthProviderType} from "../../domain/providers";

export type useFirstSignInMethodReturn = {
    isError: boolean;
    isLoading: boolean;
    signInMethod: AuthProviderType | undefined;
}

export const useFirstSignInMethod = (email: string): useFirstSignInMethodReturn => {
    const [signInMethod, setSignInMethod] = useState<AuthProviderType>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        if (!email) {
            console.error("email is required to fetch first sign in method");
            setIsError(true);
            setIsLoading(false);
            return;
        }

        fetchFirstSignInMethod(email)
            .then(method => {
                setSignInMethod(method);
                setIsLoading(false);
            }).catch( (err) => {
                console.error(err);
                setIsError(true);
                setIsLoading(false);
            });
    }, []);

    return {
        isError,
        isLoading: isLoading,
        signInMethod
    }
}
